"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSupplyPoints = void 0;
var core_1 = require("../../../core");
var supply_points_1 = require("../../kapi/v1/operations/supply-points");
var supply_points_2 = require("../../mappings/supply-points/supply-points");
var use_supply_points_query_1 = require("./use-supply-points-query");
var useSupplyPoints = function (accountId) {
    var _a = core_1.configService.getConfig(), retailer = _a.retailer, kapi = _a.kapi;
    var kapiEnabled = retailer.region === 'UK' ? kapi && kapi.supplyPoints : true;
    var legacyResponse = (0, use_supply_points_query_1.useSupplyPointsLegacyQuery)(accountId, {
        enabled: !kapiEnabled,
    });
    var legacyError = legacyResponse.status === 'error' ? legacyResponse.error : undefined;
    var _b = (0, supply_points_1.useSupplyPointQuery)({ variables: { accountId: accountId }, skip: !kapiEnabled }), kapiData = _b.data, kapiLoading = _b.loading, kapiError = _b.error;
    var data = kapiEnabled && kapiData
        ? (0, supply_points_2.mapKapiToSupplyPoint)(kapiData)
        : legacyResponse.status === 'data'
            ? legacyResponse.data
            : null;
    return {
        loading: kapiLoading || legacyResponse.isFetching,
        error: kapiError || legacyError,
        data: data,
    };
};
exports.useSupplyPoints = useSupplyPoints;
